export default __webpack_public_path__ + "static/media/536.e3079586.png";